// Engaged Tv ADM
export default {
  info: {
    NAME: 'hero-app',
  },
  api: {
    BASE_URL: 'api.hkn-pro.com',
  },
  apiGateway: {
    REGION: 'us-east-1',
    URL: 'eb2owq2ru4', // app-dev
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_1eReHNbhF',
    APP_CLIENT_ID: 'jtkr1nsugijobm9754t5uu18g',
    IDENTITY_POOL_ID: 'us-east-1:a155888f-518a-4367-989e-20d1a0c1d679',
  },
  pinpoint: {
    APP_ID: '018aa275b35243e18eb0fdcecb55f4ce',
    REGION: 'us-east-1',
  },
  // --------------------------------------------------------------------------------- S3 AUTH -----
  S3_THUMBNAILS_PROFILE: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-profile',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  S3_THUMBNAILS_INFLUENCER: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-influencer',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  // ------------------------------------------------------------------------------- S3 MOVIES -----
  S3_THUMBNAILS_CATEGORY: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-category',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  S3_THUMBNAILS_LIVE: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-live',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  S3_THUMBNAILS_CATALOG: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-catalog',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  S3_THUMBNAILS_MEDIA: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-media',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  // --------------------------------------------------------------------------------- S3 FILM -----
  S3_MEDIA_FILM: {
    REGION: 'us-east-1',
    CLOUD_FRONT: 'hero-vod-movies-source71e471f1-vuoupumvj3vl',
    BUCKET: 'hero-vod-movies-source71e471f1-vuoupumvj3vl',
    MAX_ATTACHMENT_SIZE: 500000000000, // 500 GB (era 20 GB)
  },
  // -------------------------------------------------------------------------------- S3 MUSIC -----
  S3_THUMBNAILS_GENRE: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-genre',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  S3_THUMBNAILS_LABEL: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-label',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  S3_THUMBNAILS_ARTIST: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-artist',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  S3_THUMBNAILS_ALBUM: {
    REGION: 'us-east-1',
    BUCKET: 'hero-thumbnails-album',
    MAX_ATTACHMENT_SIZE: 300000000, // 300 Mb
  },
  // -------------------------------------------------------------------------------- S3 MUSIC -----
  S3_MUSIC: {
    REGION: 'us-east-1',
    CLOUD_FRONT: 'https://d1qpj0qfcpec2e.cloudfront.net',
    BUCKET: 'hero-vod-music',
    MAX_ATTACHMENT_SIZE: 20000000000, // 20 GB (era 1 GB)
  },
};
